import { Grid, Group } from "@mantine/core"
import { SuperAdminBookingTabs } from "src/components/superadmin/bookings/SuperAdminBookingTabs"
import { EditSuperAdminBookingAction } from "src/components/superadmin/bookings/SuperAdminBookingActions"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { SuperAdminBookingView } from "src/components/superadmin/bookings/SuperAdminBookingView"
import { BookingStatusMachine } from "src/components/bookings"

export function SuperAdminBookingOverlay() {

    const { currentItem } = useAppState(state => state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent_id ? currentItem.talent?.dj_display : 'Unassigned'} @ ${currentItem?.venue?.name}, ${formatDate(currentItem?.date, 'M/d')} ${!!currentItem?.set_start_time ? '- ' : ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminBookingAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminBookingTabs overlay={true} />

            <Grid>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <BookingStatusMachine
                        showStatusBadge={true}
                        showDescriptions={true}
                        buttonSize="xs"
                        spacing="md"
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <SuperAdminBookingView />
                </Grid.Col>
            </Grid>

        </DrawerPageLayout>
    )

}